/* eslint-disable indent */
import { StatusCodes } from 'http-status-codes'

import { AppError } from 'types/local'
import { headerSelectors } from 'redux/Header/header.selectors'
// import loginPageSelectors from '@pages/login/login.selectors';

let isRefreshingToken = false
const unauthoriezedRequests: {
  resolve: (authHeaders: any) => void
  reject: () => void
}[] = []

// const retryUnauthorizedRequests = (authHeaders: any) => {
//   unauthoriezedRequests.forEach(({ resolve }) => {
//     resolve(authHeaders);
//   });
// };

// const unauthorizedRequestsFailed = () => {
//   unauthoriezedRequests.forEach(({ reject }) => {
//     reject();
//   });
// };

export const createApiHandler = (
  dispatch: any,
  getState: any,
  // refreshTokenProvider = AuthApi.refreshToken()
) => {
  const isAuthenticated = headerSelectors.isAuthenticated(getState())
  const request =
    (isRetrying = false) =>
    async <T>(createRequest: (authHeaders: any) => Promise<T>): Promise<T> => {
      const state = getState()
      const authHeaders = headerSelectors.getAuthHeaders(state)
      if (!isAuthenticated) {
        return createRequest(authHeaders)
      }
      try {
        return await createRequest(authHeaders)
      } catch (e) {
        if ((e as AppError).response?.status === StatusCodes.UNAUTHORIZED && !isRetrying) {
          // const refreshToken = loginPageSelectors.refreshToken(state) || '';
          if (isRefreshingToken) {
            return new Promise((resolve, reject) => {
              unauthoriezedRequests.push({ resolve, reject: () => reject(e) })
            })
              .then(createRequest)
              .catch(Promise.reject)
          }

          isRefreshingToken = true

          // return new Promise<any>((resolve, reject) => {
          //   refreshTokenProvider(refreshToken)
          //     .then(({ data }) => {
          //       dispatch(RealTimeDB.authFirebase({ customToken: data.fs_access_token }));
          //       dispatch({ type: loginActions.types.LOGIN.SUCCESS, payload: data });
          //       setCookie(ACCESS_TOKEN, data.access_token, data.expired_time);
          //       setCookie(REFRESH_TOKEN, data.refresh_token, data.refresh_expired_time);
          //       const newAuthHeaders = loginPageSelectors.getAuthHeaders(getState());
          //       retryUnauthorizedRequests(newAuthHeaders);
          //       resolve(request(true)(createRequest));
          //     })
          //     .catch((err) => {
          //       // unauthorizedRequestsFailed();
          //       eraseCookie(ACCESS_TOKEN);
          //       eraseCookie(REFRESH_TOKEN);
          //       dispatch({ type: rootActions.types.RESET_STATE });
          //       reject(err);
          //     })
          //     .finally(() => {
          //       isRefreshingToken = false;
          //     });
          // });
        }
        throw e
      }
    }

  return request(false)
}
